import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentType } from '../models/DocumentType';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {

  private LIST_URL = environment.apiUrl + "td/s"
  private ADD_URL = environment.apiUrl + "td"
  private DELETE_URL = environment.apiUrl + "td/"

  constructor(private httpClient: HttpClient) { }

  list(): Observable<DocumentType[]> {
    return this.httpClient.get<DocumentType[]>(this.LIST_URL)
  }

  add(documentType: DocumentType): Observable<DocumentType> {
    return this.httpClient.post<DocumentType>(this.ADD_URL, documentType)
  }

  delete(id: number): Observable<string> {
    return this.httpClient.delete(this.DELETE_URL + id.toString(), {
      responseType: "text",
    })
  }
}
